import { Tutorial } from '../tutorial.model';

export const LPS_GERENCIAR_TOUR: Tutorial = {
  id: 'lps-gerenciar',
  rota: '/painel/lancamento-contabil/gerenciar',
  passos: [
    {
      alvo: 'lps-gerenciar.grupos',
      titulo: 'Pagamentos e recebimentos separados',
      corpo: 'O quadro tem um grupo para contas a pagar e outro para contas a receber. Cada cabeçalho mostra quantas contas contábeis e categorias existem naquele tipo. Os vínculos são feitos entre contas contábeis e categorias do mesmo tipo.',
    },
    {
      alvo: 'lps-gerenciar.categoria',
      titulo: 'O que está vinculado a cada categoria',
      corpo: 'O nome no alto identifica a categoria gerencial. Ao lado, o número indica quantas contas contábeis estão vinculadas a ela. Os cartões abaixo mostram essas contas contábeis; role dentro da categoria quando a lista for maior.',
    },
    {
      alvo: 'lps-gerenciar.lp',
      titulo: 'Reconheça a conta contábil',
      corpo: 'Cada cartão mostra o código e o nome da conta contábil. O cabeçalho do grupo informa seu tipo: Contas a pagar ou Contas a receber. Uma mesma conta contábil pode aparecer em mais de uma categoria: são vínculos do mesmo cadastro.',
    },
    {
      alvo: 'lps-gerenciar.arrastar',
      titulo: 'Como reorganizar um vínculo',
      corpo: 'Segure o cartão pelo ícone ou pelo texto, arraste e solte na área das contas contábeis da categoria desejada. Use uma categoria do mesmo grupo: pagar ou receber. Isso troca o vínculo de origem pelo de destino e preserva os demais. A alteração é salva ao soltar; aguarde o fim do salvamento antes de mover outro cartão.',
    },
    {
      alvo: 'lps-gerenciar.sem-categoria',
      titulo: 'Deixar uma conta contábil sem categoria',
      corpo: 'Aqui ficam as contas contábeis que ainda não têm categoria ativa. Arraste uma delas para uma categoria para vinculá-la. No caminho inverso, soltar uma conta contábil aqui retira todos os seus vínculos com categorias. A conta contábil continua cadastrada.',
    },
    {
      alvo: 'lps-gerenciar.abrir-categorias',
      titulo: 'Abrir o cadastro de categorias',
      corpo: 'Quando não há categorias neste grupo, este botão abre a listagem para consultar ou cadastrar as categorias de pagamento ou recebimento, conforme suas permissões. Depois, retorne ao gerenciador para organizar os vínculos.',
    },
    {
      alvo: 'lps-gerenciar.voltar',
      titulo: 'Editar nome, código ou apelidos',
      corpo: 'Voltar leva à listagem de contas contábeis. Use o lápis na coluna Ações para editar o cadastro: Nome, Código e Categorias ficam na aba Informação; os apelidos de busca ficam em Aliases. As mudanças de vínculo feitas por arraste já são salvas nesta tela.',
    },
  ],
};
